import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10608752"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "popover-name"
};
import { computed } from 'vue';
import useGlobalAudioPlayer from '@/composables/global/use-global-audio-player';
import { formatTimeToString } from '@/utils/numbers';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShellHeaderMediaPlayer',
  props: {
    isOpen: {
      type: Boolean
    },
    event: {}
  },
  emits: ["didDismiss"],
  setup(__props, {
    emit: __emit
  }) {
    const {
      audioName,
      currentTime,
      duration,
      isPlaying,
      volume,
      togglePlay,
      updateTime,
      updateVolume,
      startBarChange,
      endBarChange
    } = useGlobalAudioPlayer();
    const emit = __emit;
    const volumeIcon = computed(() => {
      if (volume.value === 0) {
        return 'volume-off';
      } else if (volume.value < 25) {
        return 'volume-low';
      } else if (volume.value < 75) {
        return 'volume-medium';
      } else {
        return 'volume-high';
      }
    });
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_range = _resolveComponent("ion-range");
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_item = _resolveComponent("ion-item");
      const _component_ion_content = _resolveComponent("ion-content");
      const _component_ion_popover = _resolveComponent("ion-popover");
      return _openBlock(), _createBlock(_component_ion_popover, {
        class: "media-player",
        "is-open": _ctx.isOpen,
        event: _ctx.event,
        onDidDismiss: _cache[2] || (_cache[2] = $event => emit('didDismiss'))
      }, {
        default: _withCtx(() => [_createElementVNode("p", _hoisted_1, _toDisplayString(_unref(audioName)), 1), _createVNode(_component_ion_content, {
          class: "ion-no-padding"
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_item, {
            lines: "none"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_button, {
              size: "small",
              color: "light",
              onClick: _unref(togglePlay)
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_icon, {
                slot: "icon-only",
                name: _unref(isPlaying) ? 'pause' : 'play'
              }, null, 8, ["name"])]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_ion_range, {
              class: "duration-range",
              min: 0,
              max: _unref(duration),
              value: _unref(currentTime),
              onIonChange: _cache[0] || (_cache[0] = e => _unref(updateTime)(Number(e.detail.value))),
              onIonKnobMoveStart: _unref(startBarChange),
              onIonKnobMoveEnd: _unref(endBarChange)
            }, null, 8, ["max", "value", "onIonKnobMoveStart", "onIonKnobMoveEnd"]), _createVNode(_component_ion_label, {
              class: "timestamp-label"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formatTimeToString)(_unref(currentTime))) + " / " + _toDisplayString(_unref(formatTimeToString)(_unref(duration))), 1)]),
              _: 1
            }), _createVNode(_component_ion_icon, {
              name: volumeIcon.value
            }, null, 8, ["name"]), _createVNode(_component_ion_range, {
              class: "volume-range",
              min: 0,
              max: 100,
              value: _unref(volume),
              onIonChange: _cache[1] || (_cache[1] = e => _unref(updateVolume)(Number(e.detail.value)))
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["is-open", "event"]);
    };
  }
});